import { VideoCamera } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { TooltipContent, TooltipCustom, TooltipPortal, TooltipTrigger } from "@/components/ui/tooltip"
import { useOpenNewWindow } from "@/modules/patients/detail/progress-note/hooks/useOpenNewWindow"
import { useMedicalRecordDialogStore } from "@/modules/patients/detail/store/useCloseMedicalRecordDialogStore"
import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { Language } from "@/types/__generated__/union-types"

interface DummyVideoCallButtonProps {
  progressNoteId: string
  language: Language
}

const DummyVideoCallButton = ({ progressNoteId, language }: DummyVideoCallButtonProps) => {
  const appointmentId = useAppointmentParam()
  const openNewWindow = useOpenNewWindow()
  const setShouldIncreaseMissedCall = useMedicalRecordDialogStore((state) => state.setShouldIncreaseMissedCall)

  const handleClick = () => {
    openNewWindow(
      `/dummy-video-call?appointmentId=${appointmentId}&progressNoteId=${progressNoteId}&language=${language}`,
      "sofia-dummy-video-call",
    )
    setShouldIncreaseMissedCall(true)
  }

  return (
    <TooltipCustom>
      <TooltipTrigger asChild>
        <Button
          variant="circle"
          className="bg-developer-tool-surface hover:bg-developer-tool-surface h-10 w-10 opacity-0 transition-opacity duration-200 ease-in hover:opacity-100"
          onClick={handleClick}
          data-testid="call-video-btn">
          <VideoCamera size={24} className="text-on-primary!" />
        </Button>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent side="bottom" align="start">
          Start dummy video call
        </TooltipContent>
      </TooltipPortal>
    </TooltipCustom>
  )
}

export { DummyVideoCallButton }
